import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { AdminLayoutComponent } from './elements/admin-layout/admin-layout.component';
import { OrdersListComponent } from './pages/orders-list/orders-list.component';
import { KitchenComponent } from './pages/kitchen/kitchen.component';
import { TablesListComponent } from './pages/tables/tables.component';
import { MenuProductsComponent } from './pages/menu-products/menu-products.component';
import { CategoriesAdminPageComponent } from './pages/categories-admin/categories-admin-page.component';
import { Error404Component } from './pages/error/error404/error404.component';
import { OrdersComponent } from './pages/orders/orders.component';
import { ReadyOrdersComponent } from './pages/ready-orders/ready-orders.component';
import { SignupComponent } from './pages/signup/signup.component';
import { AuthCallbackComponent } from './auth/auth-callback.component';
import { PosPageComponent } from './pages/pos/pos-page.component';
import { EnrollIndexComponent } from './pages/auth/enroll-index.component';
import { EnrollComponent } from './pages/auth/enroll.component';
import { EnrollSuccessComponent } from './pages/auth/enroll-success.component';
import { EmailVerifySuccessComponent } from './pages/auth/email-verify-success.component';
import { LoginComponent } from './pages/auth/login.component';
import { ForgotPasswordComponent } from './pages/auth/forgot-password.component';
// Lazy load InventoryComponent to keep bundle light
// Note: keep routes minimal and aligned with sidebar menu

export const routes: Routes = [
    // Public routes (no guard)
    { path: 'signup', component: SignupComponent },
    { path: 'enroll', component: EnrollComponent },
    { path: 'enroll/success', component: EnrollSuccessComponent },
    { path: 'auth/verify-success', component: EmailVerifySuccessComponent },
    { path: 'auth/callback', component: AuthCallbackComponent },
    { path: 'login', component: LoginComponent },
    { path: 'auth/forgot-password', component: ForgotPasswordComponent },
    { path: '', component: EnrollIndexComponent },
    {
        path: 'admin', component: AdminLayoutComponent, canActivate: [AuthGuard], children: [
            { path: '', redirectTo: 'tables-list', pathMatch: 'full' },
            { path: 'kitchen', component: KitchenComponent },
            { path: 'order-list', component: OrdersListComponent },
            { path: 'tables-list', component: TablesListComponent },
            { path: 'menu-products', component: MenuProductsComponent },
            { path: 'inventory', loadComponent: () => import('./pages/inventory/inventory.component').then(m => m.InventoryComponent) },
            { path: 'resto/canales', loadComponent: () => import('./pages/resto-channels/resto-channels-page.component').then(m => m.RestoChannelsPageComponent) },
            { path: 'resto/reportes/ventas', loadComponent: () => import('./pages/reports/sales-report.component').then(m => m.SalesReportComponent), data: { roles: ['admin'] } },
            { path: 'categories-admin', component: CategoriesAdminPageComponent },
            { path: 'pos-stations', loadComponent: () => import('./pages/pos/pos-stations.component').then(m => m.PosStationsComponent) },
            { path: 'pos', component: PosPageComponent },
            { path: 'pos/:stationUuid', component: PosPageComponent },
            { path: 'foodtruck/:tableUuid', loadComponent: () => import('./ui/pages/foodtruck-pos/foodtruck-pos-page.component').then(m => m.FoodtruckPosPageComponent) },
            { path: 'orders-new/:tableUuid', component: OrdersComponent },
            { path: 'orders-edit/:tableUuid/:orderHashId', component: OrdersComponent },
            { path: 'ready', component: ReadyOrdersComponent },
            { path: 'setup/printers', loadComponent: () => import('./pages/setup/printers.component').then(m => m.PrintersComponent) },
            { path: 'setup/printer-bus', loadComponent: () => import('./pages/setup/printer-bus.component').then(m => m.PrinterBusComponent) },
            { path: 'config/flows', loadComponent: () => import('./pages/flows-config/flows-config.component').then(m => m.FlowsConfigComponent) },
        ]
    },
    { path: '**', component: Error404Component },
];
